<template>
  <svg
    :width="props.width"
    :height="props.height"
    viewBox="0 0 94 94"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse
      cx="46.334"
      cy="46.6492"
      rx="46.334"
      ry="46.6492"
      transform="matrix(1 0 0 -1 0.666016 93.2969)"
      fill="#F7F7F7"
    />
    <path
      d="M52.8131 47.926L52.0743 46.1004C40.9919 49.9451 34.4793 43.645 34.4793 36.7182C34.4793 29.3716 40.2021 23.8311 47.7908 23.8311C53.9491 23.8311 58.4173 27.8694 58.4173 33.4326C58.4173 38.8559 54.3481 40.3196 52.3844 40.7099V28.095C41.0474 27.7748 38.9602 35.4467 38.9602 37.8019C38.9602 41.0875 41.1741 43.2951 44.4698 43.2951C47.2064 43.2951 49.1467 41.6283 50.4151 39.9225V42.8608C50.4151 42.8608 60.3879 42.8734 60.3879 33.432C60.3879 26.7271 55.0907 21.8604 47.7914 21.8604C38.3512 21.8604 32.51 29.1352 32.51 36.7176C32.5094 43.2579 38.2245 52.548 52.8131 47.926ZM50.4145 35.8287C50.0904 36.6968 48.1873 41.3258 44.4692 41.3258C41.8594 41.3258 40.9295 39.5058 40.9295 37.8025C40.9295 36.0317 42.4444 30.6248 50.4138 30.0934L50.4145 35.8287ZM68.677 27.7641V16.521H54.5908L46.6838 10.0859L38.7767 16.521H24.6906V27.7641L15.1641 35.3685V73.1159H76.4302L76.4447 73.1254L76.451 73.1159H78.2035V35.3685L68.677 27.7641ZM46.6838 12.6081L51.4225 16.5204H41.9451L46.6838 12.6081ZM26.6606 18.491H66.7064V44.0642L52.3706 55.5267L46.6838 51.9202L40.9964 55.5267L26.6606 44.0636V18.491ZM24.6906 30.3178V42.4882L17.0805 36.403L24.6906 30.3178ZM17.134 38.9681L39.2369 56.6424L17.134 70.6593V38.9681ZM20.0439 71.1459L46.6838 54.2533L73.3236 71.1459H20.0439ZM76.2335 70.6593L54.1306 56.6431L76.2341 38.9687L76.2335 70.6593ZM68.677 42.4882V30.3178L76.2877 36.403L68.677 42.4882Z"
      fill="#B8B8B9"
    />
  </svg>
</template>

<script lang="ts" setup>
export interface IconListProps {
  width?: string;
  height?: string;
}

const props = withDefaults(defineProps<IconListProps>(), {
  width: "75px",
  height: "75px",
});
</script>

<style scoped></style>
